import { FetchFlagsChartPayload, FetchFlagsChartResponse } from 'reducers/dashboard/issues/flagsChart/types';
import { getToken } from 'reducers/api';
import serializeQuery from '../../../../helpers/serializeQuery';
import { apiURL } from 'config/baseURL';
import { getDummyFlagsChart } from 'utils/dashboardDummy/sites/dummyFlagsChart';
import { gatewayFetch } from '../../../../helpers/gateway';

export const fetchFlagsChart = async (payload: FetchFlagsChartPayload): Promise<FetchFlagsChartResponse> => {
	const { isDummy, ...query } = payload;
	// HANDLE DUMMY DATA
	if (isDummy) {
		const dummyFlagsChart = getDummyFlagsChart(payload);
		return {
			message: 'SUCCESS',
			data: dummyFlagsChart,
		};
	}

	try {
		const token = await getToken();
		const options: RequestInit = {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: token,
			},
		};
		const serializedQueries = serializeQuery(query);
		const url = `${apiURL}/statistics/flags/daily?${serializedQueries}`;

		const res = await gatewayFetch(url, options);

		// THROW IF RESPONSE NOT OK
		if (res.status !== 200) {
			throw new Error('');
		}

		const issuesFlagChartResult: FetchFlagsChartResponse = await res.json();
		return issuesFlagChartResult;
	} catch {
		const errorResult: FetchFlagsChartResponse = {
			message: 'FAILED',
		};
		return errorResult;
	}
};
